import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-ship-bulkcarrier')
export class ObiShipBulkcarrier extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 7.0001V10.4648H22C22 11.9496 21.4708 13.3399 20.3384 14.4532C19.8796 14.3886 19.4251 14.2576 18.9878 14.0645C18.6879 13.9353 17.9994 13.5073 17.9994 13.5073C17.9994 13.5073 17.3086 13.9292 17.0086 14.0584C15.7161 14.6143 14.2808 14.6138 12.9885 14.0572C12.6885 13.928 12 13.5 12 13.5C12 13.5 11.3115 13.928 11.0115 14.0572C9.71724 14.6147 8.27971 14.6155 6.98565 14.0572C6.6857 13.928 6 13.5 6 13.5C6 13.5 5.31146 13.9313 5.01151 14.0605C4.36195 14.3488 3.68364 14.5 3 14.5H2V10.4648H3.5V7.5C3.5 7.22385 3.72386 7 4.00001 7L9.5 7.0001ZM8 8.46483H5V10.4648H8V8.46483Z" fill="currentColor"/>
<path d="M21 18C19.97 18 18.94 17.75 18 17.25C16.11 18.25 13.89 18.25 12 17.25C10.11 18.25 7.89 18.25 6 17.25C5.05 17.75 4.03 18 3 18H2V16H3C3.68364 16 4.36195 15.8488 5.01151 15.5605C5.31146 15.4313 6 15 6 15C6 15 6.6857 15.428 6.98565 15.5572C8.27971 16.1155 9.71724 16.1147 11.0115 15.5572C11.3115 15.428 12 15 12 15C12 15 12.6885 15.428 12.9885 15.5572C14.2809 16.1139 15.7161 16.1143 17.0086 15.5584C17.3086 15.4292 17.9994 15.0073 17.9994 15.0073C17.9994 15.0073 18.6879 15.4353 18.9878 15.5645C19.6348 15.8502 20.3196 16 21 16H22V18H21Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 7.0001V10.4648H22C22 11.9496 21.4708 13.3399 20.3384 14.4532C19.8796 14.3886 19.4251 14.2576 18.9878 14.0645C18.6879 13.9353 17.9994 13.5073 17.9994 13.5073C17.9994 13.5073 17.3086 13.9292 17.0086 14.0584C15.7161 14.6143 14.2808 14.6138 12.9885 14.0572C12.6885 13.928 12 13.5 12 13.5C12 13.5 11.3115 13.928 11.0115 14.0572C9.71724 14.6147 8.27971 14.6155 6.98565 14.0572C6.6857 13.928 6 13.5 6 13.5C6 13.5 5.31146 13.9313 5.01151 14.0605C4.36195 14.3488 3.68364 14.5 3 14.5H2V10.4648H3.5V7.5C3.5 7.22385 3.72386 7 4.00001 7L9.5 7.0001ZM8 8.46483H5V10.4648H8V8.46483Z" style="fill: var(--element-active-color)"/>
<path d="M21 18C19.97 18 18.94 17.75 18 17.25C16.11 18.25 13.89 18.25 12 17.25C10.11 18.25 7.89 18.25 6 17.25C5.05 17.75 4.03 18 3 18H2V16H3C3.68364 16 4.36195 15.8488 5.01151 15.5605C5.31146 15.4313 6 15 6 15C6 15 6.6857 15.428 6.98565 15.5572C8.27971 16.1155 9.71724 16.1147 11.0115 15.5572C11.3115 15.428 12 15 12 15C12 15 12.6885 15.428 12.9885 15.5572C14.2809 16.1139 15.7161 16.1143 17.0086 15.5584C17.3086 15.4292 17.9994 15.0073 17.9994 15.0073C17.9994 15.0073 18.6879 15.4353 18.9878 15.5645C19.6348 15.8502 20.3196 16 21 16H22V18H21Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-ship-bulkcarrier': ObiShipBulkcarrier;
  }
}
